var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfessionalism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77.332 46.416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-handshake",
    "data-name": "Icon awesome-handshake",
    d: "M52.525,4.5H42.146a3.865,3.865,0,0,0-2.61,1.015L27.658,16.39c-.012.012-.024.036-.036.048a4.806,4.806,0,0,0-.254,6.767,5.04,5.04,0,0,0,6.779.326c.012-.012.036-.012.048-.024l9.654-8.845a1.933,1.933,0,0,1,2.61,2.852L43.306,20.4,60.9,34.684a8.705,8.705,0,0,1,.955.93V12.233l-6.6-6.6A3.839,3.839,0,0,0,52.525,4.5Zm13.207,7.757V39.311A3.862,3.862,0,0,0,69.6,43.178h7.733V12.257Zm5.8,27.054a1.933,1.933,0,1,1,1.933-1.933A1.939,1.939,0,0,1,71.532,39.311ZM0,43.166H7.733A3.862,3.862,0,0,0,11.6,39.3V12.257H0Zm5.8-7.721a1.933,1.933,0,1,1-1.933,1.933A1.939,1.939,0,0,1,5.8,35.445Zm52.67,2.247L40.43,23.048,36.805,26.37A8.7,8.7,0,1,1,25.048,13.55L34.932,4.5H24.807a3.86,3.86,0,0,0-2.731,1.136l-6.609,6.6V39.287h2.211l10.935,9.9A7.732,7.732,0,0,0,39.488,48.06l.024-.024,2.163,1.873a4.49,4.49,0,0,0,6.319-.652l3.794-4.664.652.532a3.861,3.861,0,0,0,5.437-.568l1.148-1.414a3.874,3.874,0,0,0-.556-5.449Z",
    transform: "translate(0 -4.5)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalism);
export default __webpack_public_path__ + "static/media/professionalism.975cf68ab7446d46694d06aadb16ecc1.svg";
export { ForwardRef as ReactComponent };